import api from 'utils/apiClient';

export const authLogin = (data) => {
  return api.post('/login', data);
};

export const getCurrentUser = () =>
  api.get('/admins/current', {
    headers: {
      Accept: 'application/json',
    },
  });
